<template>
	<div class="log-content" v-loading="loading">
		<div class="head">
			<h3><translate>Viewing Of Log Content</translate></h3>
			<div>
				<el-button type="text" v-clipboard:copy="logContent" v-clipboard:success="copySuccess" v-clipboard:error="copyError">
					<translate>Copy</translate>
				</el-button>
				<el-button type="text" @click="downLoad()"><translate>Download</translate></el-button>
			</div>
		</div>
		<pre>{{ logContent }}</pre>

		<!--是否解冻-->
		<el-dialog title="日志解冻" :visible.sync="freezeShow" class="dialog" top="20px" @close="closeDialog">
			<div class="dialog-content" v-loading="pollingLoading" element-loading-text="日志正在解冻中，请稍等...">
				<p class="text" v-if="pollingCode == 'OSSFileAvailable'">解冻完成，文件正在下载...</p>
				<p class="text" v-else>检测到您所选择的日志文件目前处于"冷冻"归档状态，如您需要继续"下载"，请点击"确认"发起解冻请求。日志文件"解冻"通常需要5-10分钟左右，请耐心等待。</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :disabled="pollingLoading" link @click="freezeShow = false">取消</el-button>
				<el-button v-if="pollingLoading || pollingCode == 'OSSFileArchived'" type="primary" :disabled="pollingLoading" @click="handleFreezeConfirm">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import STORE_CONST from '../store/consts'

import Utility from '../Utils'
import { baseUrl } from '../config'
import Polling from '../plugins/polling'

export default {
	name: 'purchase',
	data() {
		return {
			loading: false,
			params: {},
			logContent: '',
			freezeShow: false,
			freezeShowRow: '',
			pollingTimer: null,
			pollingLoading: false,
			pollingCode: '', //OSSFileArchived 冻结  /  OSSFileRestoring 解冻中  /  OSSFileAvailable 已解冻
		}
	},
	computed: {
		attrText() {
			return this.getTransitionText()
		},
	},
	created() {
		this.params = Utility.Utils.getUrlParams()

		this.getLog()
	},
	methods: {
		// 获取翻译文本
		getTransitionText() {
			return {
				logContentView: this.$gettext('Viewing Of Log Content'),
			}
		},

		copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success',
			})
			e.clearSelection()
		},
		copyError(e) {
			this.$notify({
				message: this.$gettext('Copy Failed!'),
				type: 'failed',
			})
		},

		closeDialog() {
			this.freezeShow = false
			clearTimeout(this.pollingTimer)
		},
		getLog() {
			this.loading = true
			this.$store
				.dispatch(STORE_CONST.LOG.VIEW_LOG, {
					params: { ...this.params, show: 1 },
				})
				.then((res) => {
					if (res.code == 'OSSFileArchived') {
						this.pollingCode = res.code
						this.freezeShow = true
					} else if (res.code == 'OSSFileRestoring') {
						this.pollingCode = res.code
						this.params.check = 1
						this.freezeShow = true
						this.pollingLoading = true
						this.pollingTimer = setTimeout(() => {
							this.polling(params)
						}, 3000)
					} else {
						// this.logContent = res || '暂无日志内容'
						// 过滤ANSI转义序列后再赋值
						const cleanContent = Utility.Utils.filterAnsiEscapeCodes(res || '')
						this.logContent = cleanContent || '暂无日志内容'
					}
					this.loading = false
				})
				.catch((err) => {
					this.$message.error('日志内容加载失败')
					this.loading = false
				})
		},

		polling(params) {
			this.$store.dispatch(STORE_CONST.LOG.UNFREEZE, { params: params }).then((res) => {
				console.log(res, 'res轮询')
				if (Object.keys(res).length) {
					if (res.code == 'OSSFileArchived') {
						this.pollingCode = res.code
						// 打开解冻确认弹窗
						this.freezeShow = true
					} else if (res.code == 'OSSFileRestoring') {
						this.pollingCode = res.code
						params.check = 1
						this.freezeShow = true
						this.pollingLoading = true
						this.pollingTimer = setTimeout(() => {
							this.polling(params)
						}, 3000)
					}
				} else {
					this.pollingCode = 'OSSFileAvailable'
					this.pollingLoading = false
					this.freezeShow = false
					this.getLog(row) // 查看日志
				}
			})
		},

		handleFreezeConfirm() {
			// 判断是下载还是查看操作
			this.polling({ ...this.params, check: 0 })
		},
		downLoad() {
			const url = `${baseUrl.apiUrl}/download_tunnel_log?${Object.keys(this.params)
				.map((key) => `${key}=${encodeURIComponent(this.params[key])}`)
				.join('&')}`
			window.open(url, '_blank')
		},
	},
	components: {},
	destroyed() {
		clearTimeout(this.pollingTimer)
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
.log-content {
	height: 100vh !important;
	.head {
		height: 60px;
		padding: 0 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		h3 {
			font-size: 24px;
		}
	}
	pre {
		height: calc(100% - 60px);
		white-space: pre-wrap; // 保留空格和换行
		// word-wrap: break-word; // 禁用自动换行
		overflow-x: auto; // 横向滚动
		font-family: 'Consolas', 'Monaco', monospace; // 等宽字体，适配日志
		font-size: 14px;
		line-height: 1.5;
		color: #333;
		background-color: #f8f8f8;
		padding: 15px;
		border-radius: 4px;
		margin: 0;
	}
}
</style>



// WEBPACK FOOTER //
// excel-log-view.vue?65a17b23